var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-page-components"},[_c('div',{staticClass:"page-wapper"},[_c('div',{staticClass:"page-main"},[_c('div',{staticClass:"image-content"},[_vm._t("left")],2),_c('div',{staticClass:"page-content"},[_vm._t("right")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }